function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import t from "../../scripts/i18n";
import { TextField } from '@signicat/designi/components/inputs';
import { Icon } from '@signicat/designi/components/icons';
import _ from "lodash";
import "../../styling/components/common/PageHeader.css";

var PageHeader = function PageHeader(props) {
  var title = props.title,
      info = props.info,
      onSearch = props.onSearch;
  var searchValue = useSelector(function (state) {
    return state.contacts.tableState.wildcard;
  });
  var searchInput = useRef(null);

  var handleOnSearch = _.debounce(function (e) {
    onSearch(searchInput.current.value);
  }, 500);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      infoHover = _useState2[0],
      setInfoHover = _useState2[1];

  useEffect(function () {
    searchInput.current.value = searchValue;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "pageheader"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, title, info && /*#__PURE__*/React.createElement("div", {
    className: "info-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    name: "infoOutline",
    onClick: function onClick() {
      return setInfoHover(!infoHover);
    },
    onMouseEnter: function onMouseEnter() {
      return setInfoHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInfoHover(false);
    }
  }), infoHover && /*#__PURE__*/React.createElement("div", {
    className: "tooltip"
  }, info))), /*#__PURE__*/React.createElement(TextField, {
    inputRef: searchInput,
    className: onSearch ? "" : "visibility-hidden",
    type: "text",
    placeholder: t("page_header_search"),
    onChange: handleOnSearch,
    icon: "search"
  }));
};

export default PageHeader;